import React, { useState } from "react";
import Popup from "../../../EventOrganiser/Popup";
import { handlePopup } from "../redux/slice";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import userStore from "../../../../zustand/userStore";
import { CreateSimpleQuestionThunk } from "../redux/thunk";

export default function AddQuestion() {
  const dispatch = useDispatch();

  const {
    selectedQnCategory: selectedCategory,
    formData: formData2,
    selectedChapter,
    loader: loading,
  } = useSelector((store) => store.createQstnPaper);

  const userData = userStore((state) => state.user);

  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState(["", "", "", ""]);
  const [images, setImages] = useState([]);

  if (!selectedCategory) return null;
  const isMCQ = selectedCategory.label === "Multiple Choice Questions";

  const updateOption = (value, i) => {
    const arr = [...options];
    arr[i] = value;
    setOptions(arr);
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    let validFiles = [];
    let hasLargeFile = false;

    files.forEach((file) => {
      if (file.size > 1 * 1024 * 1024) {
        hasLargeFile = true;
      } else {
        validFiles.push(file);
      }
    });

    if (hasLargeFile) {
      alert("File size should be less than 1 MB");
      e.target.value = ""; // reset input
      return; // stop here, don't add files
    }

    if (validFiles.length > 0) {
      setImages((prev) => [...prev, ...validFiles]);
    }
  };

  const removeImage = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append("question_text", question);
    fd.append("question_typeid", selectedCategory.value);
    fd.append("subject_id", formData2.subject);
    fd.append("class_id", formData2.class);
    fd.append("chapter_id", selectedChapter);
    fd.append("difficulty_id", selectedCategory.difficulty_id || "");
    fd.append("created_by", userData.id || "");

    if (isMCQ) {
      fd.append(
        "options",
        JSON.stringify(
          options.map((opt, i) => ({
            option_sort: i + 1,
            text: opt,
            is_correct: false,
          }))
        )
      );
    }

    images.forEach((file) => fd.append("images", file));
    dispatch(CreateSimpleQuestionThunk(fd)).then((action) => {
      if (action.meta.requestStatus === "fulfilled") {
        dispatch(handlePopup(false));
      }
    });
  };

  return (
    <Popup
      title="Add New Question"
      minHeight="480px"
      maxWidth="850px"
      onClose={() => dispatch(handlePopup(false))}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <h5 className="mb-3">{selectedCategory.label}</h5>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Question</label>
            <textarea
              className="form-control"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              rows={3}
              required
              disabled={loading}
            />
          </div>

          {isMCQ && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <label className="form-label">Options</label>

              <div className="d-flex flex-wrap gap-3">
                {options.map((opt, idx) => (
                  <div key={idx} style={{ width: "48%" }}>
                    <label className="small">Option {idx + 1}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={opt}
                      onChange={(e) => updateOption(e.target.value, idx)}
                      placeholder={`Enter option ${idx + 1}`}
                      required
                      disabled={loading}
                    />
                  </div>
                ))}
              </div>
            </motion.div>
          )}

          <div className="mt-3">
            <label className="form-label ">
              <span>Upload Images</span>
              &nbsp;
              <span
                style={{ fontSize: "12px", color: "#333", fontWeight: "500" }}
              >
                (Allowed: JPG, JPEG, PNG)
              </span>
              &nbsp;
              <span
                style={{ fontSize: "12px", color: "red", fontWeight: "600" }}
              >
                Upload below 1 MB size files only.
              </span>
            </label>
            <input
              type="file"
              accept=".png, .jpg, .jpeg"
              multiple
              className="form-control"
              onChange={handleImageChange}
              disabled={loading}
            />

            {images.length > 0 && (
              <div className="mt-3 d-flex gap-3 flex-wrap">
                {images.map((img, i) => (
                  <div key={i} className="position-relative">
                    <img
                      src={URL.createObjectURL(img)}
                      width={100}
                      height={100}
                      style={{
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                      }}
                    />

                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      style={{
                        position: "absolute",
                        top: -8,
                        right: -8,
                        borderRadius: "50%",
                        padding: "2px 6px",
                      }}
                      onClick={() => removeImage(i)}
                      disabled={loading}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="mt-4 text-end">
            <button className="btn btn-primary px-4" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </motion.div>
    </Popup>
  );
}
